import { useEffect } from 'react';
import { appThemeApiRef, useApi } from '@backstage/frontend-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';

// TEMPORARY WORKAROUND — safe to remove once Microsoft/Entra auth is enabled.
//
// Problem: guest sessions have no user identity, so appThemeApi has no stored
// preference and falls back to the first-registered theme (Backstage's built-in
// light theme), ignoring Silk.Shuttle entirely.
//
// Fix: on mount, if no theme is stored, force 'shuttle'. If the user has already
// picked a theme explicitly, getActiveThemeId() returns their choice and we skip.
//
// PATH TO PROPER MULTI-THEME SUPPORT (when Entra auth is live):
//   1. Delete this file and remove themeForcerExtension from theme/index.tsx.
//   2. In app-config.yaml: remove the `theme:app/light: false` and
//      `theme:app/dark: false` lines — or replace the built-in themes with a
//      branded Silk light variant (second ThemeBlueprint in theme/index.tsx).
//   3. Backstage's user settings page already has a theme picker UI that shows
//      all registered ThemeBlueprints and persists the user's choice per-account.
//      No additional code needed — just real user identities.
const ThemeForcer = (props: { children: React.ReactNode }) => {
  const appThemeApi = useApi(appThemeApiRef);

  useEffect(() => {
    if (!appThemeApi.getActiveThemeId()) {
      appThemeApi.setActiveThemeId('shuttle');
    }
  }, [appThemeApi]);

  return <>{props.children}</>;
};

export const themeForcerExtension = AppRootWrapperBlueprint.make({
  name: 'theme-forcer',
  params: {
    component: ThemeForcer,
  },
});
